// Eigen creditinstelling per activiteit (ClickUp 86c6gv8yw).
//
// Een activiteit met eigen credits heeft een apart tegoed: aanmelden daarop gaat
// niet van de credits van de bedrijfspagina af. De server beslist
// (CreditsService::allowance in Laravel); deze helpers spiegelen alleen wat de
// frontend zonder server moet weten: de datumkiezer van wie niet is ingelogd, en
// hoe de regel in de credit-pop-up en op de activiteitspagina leest.
//
// Bewust import-vrij: scripts/test-activity-credits.mjs laadt dit bestand in een vm.

/** Of de activiteit haar eigen creditinstelling toepast: schakelaar aan én een aantal. */
export function hasOwnCredits(activity) {
  const content = activity?.content;
  return (
    !!content?.own_credits &&
    content.credits !== "" &&
    content.credits !== null &&
    content.credits !== undefined
  );
}

/**
 * Het tegoed dat een aanmelding op deze activiteit aanspreekt: dat van de
 * activiteit als ze eigen credits heeft, anders dat van de bedrijfspagina.
 * `credits` is null bij geen limiet.
 */
export function creditAllowance(pageSettings, activity) {
  if (hasOwnCredits(activity)) {
    return {
      credits: Math.max(0, Number(activity.content.credits)),
      period: activity.content.credits_period || "day",
    };
  }
  const credits = pageSettings?.credits;
  return {
    credits: credits === "" || credits === null || credits === undefined ? null : Number(credits),
    period: pageSettings?.period || "day",
  };
}

/**
 * Een regel uit GET /v1/users/{page}/credits/activities als wat er staat:
 * hoeveel er over is van hoeveel, in welke periode. `none` is een activiteit
 * met 0 credits: daar is niets te boeken.
 */
export function activityCreditLine(line) {
  const max = Number(line?.credits) || 0;
  const used = Number(line?.used) || 0;
  return {
    left: Math.max(0, max - used),
    max,
    used: Math.min(used, max),
    period: ["day", "week", "month", "year"].includes(line?.period) ? line.period : "day",
    none: max === 0,
  };
}
